import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { authGuard } from './guards/auth/auth.guard';
import { notAuthGuard } from './guards/auth/not-auth.guard';
import { roleGuard } from './guards/role/role.guard';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [notAuthGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/landing-page/landing-page.component').then(m => m.LandingPageComponent),
        pathMatch: 'full'
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () => import('./pages/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent)
      },
      {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginComponent)
      }
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard-page/dashboard-page.component').then(m => m.DashboardPageComponent)
      },
      {
        path: 'transactions',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/transactions-page/transactions-page.component').then(m => m.TransactionsPageComponent)
      },
      {
        path: 'fixed-expenses',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/fixed-expenses-page/fixed-expenses-page.component').then(m => m.FixedExpensesPageComponent)
      },
      {
        path: 'cards',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/cards-page/cards-page.component').then(m => m.CardsPageComponent)
      },
      {
        path: 'cards/dashboard',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/cards-dashboard-page/cards-dashboard-page.component').then(m => m.CardsDashboardPageComponent)
      },
      {
        path: 'groups',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/groups-page/groups-page.component').then(m => m.GroupsPageComponent)
      },
      {
        path: 'groups/:id',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/group-detail-page/group-detail-page.component').then(m => m.GroupDetailPageComponent)
      },
      {
        path: 'wallets',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/wallets-page/wallets-page.component').then(m => m.WalletsPageComponent)
      },
      {
        path: 'analytics',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/analytics-page/analytics-page.component').then(m => m.AnalyticsPageComponent)
      },
      {
        path: 'settings',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/settings-page/settings-page.component').then(m => m.SettingsPageComponent)
      },
      {
        path: 'help',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/help-page/help-page.component').then(m => m.HelpPageComponent)
      },
      {
        path: 'pro',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/pro-page/pro-page.component').then(m => m.ProPageComponent)
      },
      {
        path: 'invite/:token',
        loadComponent: () => import('./pages/group-invite/group-invite.component').then(m => m.GroupInviteComponent)
      },
      {
        path: 'admin',
        canActivate: [roleGuard],
        loadComponent: () => import('./pages/admin/admin-permissions.component').then(m => m.AdminPermissionsComponent)
      }
    ]
  }
];
